import {
  Avatar,
  Box,
  Button,
  Divider,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import CompaniesNavbar from "./CompaniesNavbar";
import CameraIcon from "../../UI/CameraIcon";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Gmailicon from "../../UI/Gmailicon";
import LocationIconCompanyDetails from "../../UI/LocationIconCompanyDetails";
import PhoneIconCompanyDetails from "../../UI/PhoneIconCompanyDetails";
import WebLinkIconCompanyDetails from "../../UI/WebLinkIconCompanyDetails";
import MenuDotsCompanyDetails from "../../UI/MenuDotsCompanyDetails";
import JoinPitchersDark from "./JoinPitchersDark";
import FooterSection from "../JobBoardHomepage/Footer/FooterSection";
const jobOpenings = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
const featuredCardsData = [
  {
    iconSrc: "/icons/moneyIcon.svg",
    iconSrcDarkMode: "/icons/employeeIconDarkModeUnActive.svg",
    text: "1339 employees",
  },
  {
    iconSrc: "/icons/locationIconReviewsSection.svg",
    iconSrcDarkMode: "/icons/locationIconReviewsSectionWhite.svg",
    text: "Seattle, WA",
  },
];
const detailsData = [
  { icon: Gmailicon, text: "amranstudio@gmail.com" },
  {
    icon: LocationIconCompanyDetails,
    text: "Modern House Suites No. 187, Toronto, CA",
  },
  { icon: PhoneIconCompanyDetails, text: "+12 3456 7890" },
  { icon: WebLinkIconCompanyDetails, text: "https://amranstudio.com" },
];
const jobBoardNavbarButtons = [
  { text: "About", route: "" },
  { text: "Jobs", route: "" },
  { text: "Employees", route: "" },
  { text: "Location", route: "" },
  { text: "Updates", route: "" },
  { text: "Community", route: "" },
  { text: "Reviews", route: "" },
];
const avatarsList = [1, 2, 3, 4, 5];
const bioPictures = [1, 2, 3, 4, 5];
function CompanyDetails() {
  const [activeIndux, setActiveIndex] = useState(0);
  const navigate = useNavigate();
  return (
    <Stack sx={{ bgcolor: "#1c1c1c" }}>
      <CompaniesNavbar />
      <Stack>
        <Box
          sx={{
            // backgroundImage: `url(/images/desert-pattern.jpeg)`,
            // backgroundSize: "cover",
            // backgroundPosition: "center",
            // backgroundRepeat: "no-repeat",
            // //   width: "245px",
            height: "231px",
            display: "flex",
            position: "relative",
            mb: "90px",
            bgcolor: "#D9D9D9",
            border: "none",
            cursor: "pointer",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CameraIcon width="40" height="40" />
          <input type="file" hidden accept="image/*" />
          <Avatar
            // src={}
            alt="Profile Picture"
            sx={{
              width: 200,
              height: 200,
              objectFit: "cover",
              //   border: "9px solid #ffffff",
              position: "absolute",
              bottom: -85,
              ml: "18px",
              // mb: "-50px",
              bgcolor: "#F9F9F9",
              color: "#F9F9F9",
              justifySelf: "start",
              alignSelf: "start",
              left: 80,
            }}
          >
            <CameraIcon width="40" height="40" />
          </Avatar>
        </Box>
        <Stack sx={{ px: "100px" }}>
          <Stack direction="row" sx={{ justifyContent: "space-between" }}>
            <Box>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "700",
                  fontSize: "18px",
                  lineHeight: "23px",
                  fontFamily: "Inter",
                  textAlign: "start",
                  color: "#ffffff",
                  py: "10px",
                }}
              >
                TechWorks Incorporation
              </Typography>
              {featuredCardsData.map((data) => (
                <>
                  <Stack
                    direction="row"
                    sx={{
                      alignItems: "center",
                      gap: "6px",
                      pt: "0px",
                      justifyContent: "start",
                    }}
                  >
                    <Box
                      component="img"
                      src={data.iconSrcDarkMode}
                      sx={{ width: "15px", height: "15px" }}
                    ></Box>
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: "400",
                        fontSize: "14px",
                        lineHeight: "24px",
                        fontFamily: "Inter",
                        color: "#c9c9c9",
                        textAlign: "center",
                      }}
                    >
                      {data.text}
                    </Typography>
                  </Stack>
                </>
              ))}
            </Box>
            <Box>
              {" "}
              <Stack direction="row" spacing={-1.5} sx={{ pb: "10px" }}>
                {avatarsList.map((avatar) => (
                  <Avatar
                    sx={{
                      width: "58px",
                      height: "58px",
                      border: "2px solid white",
                    }}
                  >
                    <CameraIcon width="16px" height="16px" />
                  </Avatar>
                ))}
              </Stack>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "500",
                  fontSize: "18px",
                  //   lineHeight: "24px",
                  fontFamily: "Inter",
                  color: "#8d8d8d",
                }}
              >
                Employes from your network
              </Typography>
            </Box>
          </Stack>
          <Stack
            direction="row"
            sx={{ justifyContent: "space-between", mt: "70px", mb: "50px" }}
          >
            {jobBoardNavbarButtons.map((btn, i) => {
              const isActive = i === activeIndux;
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {" "}
                  <Button
                    variant="text"
                    sx={{
                      color: isActive ? "#fddf59" : "#FFFFFF",
                      textTransform: "none",
                      px: "20px",
                      fontWeight: isActive ? "700" : "500",
                      fontFamily: "Inter",
                      fontSize: "18px",
                    }}
                    onClick={() => {
                      setActiveIndex(i);
                      navigate(btn.route);
                    }}
                  >
                    {btn.text}
                  </Button>
                  {isActive && (
                    <Divider
                      orientation="horizontal"
                      sx={{
                        color: "#fddf59",
                        border: "2px solid #fddf59",
                        borderRadius: "50px",
                        // mt: "16px",
                      }}
                    />
                  )}
                </Box>
              );
            })}
          </Stack>
          <Stack direction="row" sx={{ gap: "10px" }}>
            <Stack
              sx={{
                bgcolor: "#262626",
                p: "20px",
                borderRadius: "10px",
                width: "65%",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "500",
                  fontSize: "18px",
                  fontFamily: "Inter",
                  textAlign: "start",
                  color: "#ffffff",
                  pb: "8px",
                }}
              >
                Bio
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "400",
                  fontSize: "18px",
                  fontFamily: "Inter",
                  textAlign: "start",
                  color: "#ffffff",
                  maxWidth: "850px",
                }}
              >
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. It has
                survived not only five centuries, but also the leap into the
                industry's
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "12px",
                  pt: "10px",
                }}
              >
                {bioPictures.map((bio) => (
                  <Button
                    sx={{
                      bgcolor: "#D9D9D9",
                      p: "40px",
                      px: "60px",
                      borderRadius: "7px",
                    }}
                  >
                    <CameraIcon width="24px" height="24px" />
                  </Button>
                ))}
              </Box>
            </Stack>
            <Stack
              sx={{
                bgcolor: "#262626",
                p: "20px",
                borderRadius: "10px",
                width: "35%",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "500",
                  fontSize: "18px",
                  fontFamily: "Inter",
                  textAlign: "start",
                  color: "#ffffff",
                  pb: "10px",
                }}
              >
                Details
              </Typography>
              <Stack direction="column" sx={{ gap: "16px" }}>
                {detailsData.map((detail) => (
                  <Stack
                    direction="row"
                    sx={{ alignItems: "center", gap: "20px" }}
                  >
                    <Box
                      sx={{
                        bgcolor: "#000000",
                        // width: "44px",
                        // height: "44px",
                        borderRadius: "50%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        p: "10px",
                      }}
                    >
                      <detail.icon />
                    </Box>
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: "400",
                        fontSize: "18px",
                        fontFamily: "Inter",
                        textAlign: "start",
                        color: "#ffffff",
                      }}
                    >
                      {detail.text}
                    </Typography>
                  </Stack>
                ))}
              </Stack>
            </Stack>
          </Stack>
          <Stack
            sx={{
              bgcolor: "#262626",
              p: "20px",
              borderRadius: "10px",
              mt: "10px",
            }}
          >
            <Typography
              variant="body2"
              sx={{
                fontWeight: "500",
                fontSize: "18px",
                fontFamily: "Inter",
                textAlign: "start",
                color: "#ffffff",
                pb: "8px",
              }}
            >
              200 Open Jobs
            </Typography>

            <Stack
              direction="row"
              sx={{ flexWrap: "wrap", rowGap: "14px", columnGap: "80px" }}
            >
              {jobOpenings.map((job) => (
                <Stack direction="row" sx={{ gap: "70px" }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    {" "}
                    <Avatar
                      sx={{
                        width: "36px",
                        height: "36px",
                      }}
                    >
                      <CameraIcon width="16px" height="16px" />
                    </Avatar>
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: "500",
                        fontSize: "16px",
                        fontFamily: "Inter",
                        textAlign: "start",
                        color: "#ffffff",
                      }}
                    >
                      UI/UX Designer
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: "500",
                        fontSize: "16px",
                        fontFamily: "Inter",
                        textAlign: "start",
                        color: "#8B8B8B",
                      }}
                    >
                      $20-45 hourly
                    </Typography>
                    <IconButton>
                      <MenuDotsCompanyDetails />
                    </IconButton>
                  </Box>
                </Stack>
              ))}
            </Stack>
          </Stack>
        </Stack>
        <JoinPitchersDark />
        <FooterSection />
      </Stack>
    </Stack>
  );
}

export default CompanyDetails;
